"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input, Textarea } from "rizzui";

export default function EducaeetCTAEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => updateContent("title", v)}
              placeholder="Join thousands of students"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => updateContent("description", v)}
              placeholder="Start your learning journey today"
              multiline
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Query Form Settings</h4>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1.5 block">
                Form Heading Title
              </label>
              <Input
                value={content.formTitle || "Submit Your Query"}
                onChange={(e) => updateContent("formTitle", e.target.value)}
                placeholder="Submit Your Query"
                className="!rounded-lg text-sm"
              />
            </div>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Contact Information</h4>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1.5 block">
                Address
              </label>
              <Textarea
                value={content.address || ""}
                onChange={(e) => updateContent("address", e.target.value)}
                placeholder="Enter office address..."
                className="!rounded-lg text-sm"
                rows={2}
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1.5 block">
                Phone Number
              </label>
              <Input
                value={content.phone || ""}
                onChange={(e) => updateContent("phone", e.target.value)}
                placeholder="e.g. +1 (305) 902-3242"
                className="!rounded-lg text-sm"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1.5 block">
                Email Address
              </label>
              <Input
                value={content.email || ""}
                onChange={(e) => updateContent("email", e.target.value)}
                placeholder="e.g. hello@example.com"
                className="!rounded-lg text-sm"
              />
            </div>
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Social Media Handles</h4>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1 block">Facebook URL</label>
              <Input
                value={content.facebookUrl || ""}
                onChange={(e) => updateContent("facebookUrl", e.target.value)}
                placeholder="https://facebook.com/..."
                className="!rounded-lg text-xs"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1 block">Twitter / X URL</label>
              <Input
                value={content.twitterUrl || ""}
                onChange={(e) => updateContent("twitterUrl", e.target.value)}
                placeholder="https://twitter.com/..."
                className="!rounded-lg text-xs"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1 block">Instagram URL</label>
              <Input
                value={content.instagramUrl || ""}
                onChange={(e) => updateContent("instagramUrl", e.target.value)}
                placeholder="https://instagram.com/..."
                className="!rounded-lg text-xs"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase tracking-wider mb-1 block">YouTube URL</label>
              <Input
                value={content.youtubeUrl || ""}
                onChange={(e) => updateContent("youtubeUrl", e.target.value)}
                placeholder="https://youtube.com/..."
                className="!rounded-lg text-xs"
              />
            </div>
          </div>
        </div>
      }
    />
  );
}
